<script>
import {
  attendance_attendanceLeaveApplications, attendance_attendanceLeaveApplications_judgeLeave,
  attendance_attendanceRecords,
  attendance_attendanceRecords_attendanceTime, attendance_calendarInfo_list, processIsCord
} from "@/lib/request";
import {getLocalItem,setLocalItem} from "@/untils/common";
import {Dialog} from "vant";
import { ClientId } from "@/lib/cli";
import { loginRequest } from "@/lib/request"
export default {
  name: 'clockIn',
  data() {
    return {
      removeListener:null,
      routerType:'',
      userId:'',
      url_openid:'',
      stateName:'',
      clockTime:null,
      currentTime:null,
      current:0,
      disableCheck:false,
      listType:[
        {name:'打卡',icon:'smile-o', css:'punch',state:0,checked:false,disable:false},
        {name:'请假',icon:'underway-o',css:'leave',state:2,checked:false,disable:false},
        {name:'休假',icon:'tosend',css:'vacation',state:1,checked:false,disable:false},
        {name:'借调',icon:'exchange', css:'transfer',state:3,checked:false,disable:false},
      ],
      tipsFlag:false,
      tipsObj:{}
    }
  },
  methods:{
    getCalendarXZ(deptName){
      this.disableCheck = true;
      let date = this.formatDate();
      let regionName = '';
      // 地市
      if(deptName){
        //从消息通知进入
        if(deptName.split('-')[1]){
          regionName = deptName.split('-')[0];
        }else{
          regionName = deptName;
        }
      }else{
        //从首页进入
        if(getLocalItem('deptName')){
          if(getLocalItem('deptName').split('-')&&getLocalItem('deptName').split('-').length>0){
            if(getLocalItem('deptName').split('-')[1]){
              regionName = getLocalItem('deptName').split('-')[0];
            }else{
              regionName = getLocalItem('deptName');
            }
          }
        }
      }
      if(!regionName){
        this.$toast('暂无地市！');
        return false;
      }
      attendance_calendarInfo_list({
        date:date,
        regionName:regionName
      }).then((res)=>{
        if(res){
          if(res.data){
            this.disableCheck = false;
            if(res.data.code===200) {
              // calendarType日历类型：0 工作日、1 周末休息日、2 节假日
              if(res.data.rows&&res.data.rows.length>0){
                if(res.data.rows[0].calendarType!==0){
                  // 不能打卡
                  this.disableCheck = true;
                }
              }else{
                // 不能打卡
                this.disableCheck = true;
              }
            }else{
              this.$toast.fail(res.data.msg);
              return false;
            }
          }
        }
      });
    },
    getBack(){
      this.$router.push({path: '/techHome'});
    },
    // 格式化日期
    formatDate() {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },
    formatTime(date) {
      const d = new Date(date);
      return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
    },
    updateTime() {
      const now = new Date();
      this.clockTime = this.formatTime(now);
      const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      this.currentTime = `${now.getFullYear()}年${now.getMonth() + 1}月${now.getDate()}日 ${weekdays[now.getDay()]}`;
    },
    getSubmit(item){
      let params = {};
      if(this.userId){
        params.userId = this.userId
      }
      if(!params.userId){
        this.$toast('无法获取userId！');
        return false;
      }
      // 考勤状态：0 在勤；1 休假；2 请假；3 借调
      if(item.state===0){
        // 打卡操作
        params.attendanceStatus = 0;//打卡（在勤）
        console.log('--打卡--',params)
        this.openPunchConfirm(params);
        // Dialog({
        //   title: `确认${item.name}提示`,
        //   message: `确定要${item.name}?`,
        //   confirmButtonText: '确定',
        //   showCancelButton:true,
        //   cancelButtonText:'取消',
        //   theme: 'round-button',
        // }).then(() => {
        //    //确定
        // }).catch((error)=>{
        //   // 取消
        //   console.log('取消',error);
        // });
      }else{
        // 请假，休假，借调操作
        params.attendanceStatus = item.state;
        console.log('--请假，休假，借调--',params)
        this.getPunchOther(params)
        // 非打卡操作（请假，休假，借调）
        // Dialog({
        //   title: `确认${item.name}提示`,
        //   message: `确定要提交${item.name}申请吗？`,
        //   confirmButtonText: '确定',
        //   showCancelButton:true,
        //   cancelButtonText:'取消',
        //   theme: 'round-button',
        // }).then(() => {
        //   //确定
        // }).catch((error)=>{
        //   // 取消
        //   console.log('取消',error);
        // });
      }
    },
    async openModal(item){
      this.tipsObj = item;
      if(this.disableCheck){
        this.$toast('不在工作日范围，不能操作！');
        return false;
      }
      if(this.stateName!==''){
        const matchedItem = this.listType.find(item => item.name === this.stateName);
        if(matchedItem&&matchedItem.name){
          // 非打卡
          // 如果有name则是除非打卡以外的状态
          if(this.stateName!==item.name){
            // 已请假，点击休假、借调或打卡按钮，以此类推
            this.$toast(`您当前已${this.stateName}，无法${item.name}！`);
            return false;
          }else{
            // 已请假，点击请假按钮，以此类推
            this.$toast(`您当前已${item.name}，无法重复操作${item.name}！`);
            return false;
          }
        }else{
          // 打卡
          if(item.name==='打卡'){
            // 已打卡，点击打卡按钮提示信息
            this.$toast(`您当前已打卡，无法重复操作${item.name}！`);
            return false;
          }else{
            // 已打卡，点击请假、休假、借调按钮提示信息
            this.$toast(`您当前已打卡，无法${item.name}！`);
            return false;
          }
        }
      }
      let params = {};
      if(this.userId){
        params.userId = this.userId
      }
      if(!params.userId){
        this.$toast('无法获取userId！');
        return false;
      }
      if(item.name!=='打卡'){
        // 非打卡
        //判断是否可以请假休假借调
        const resResult = await this.getIsFlag(params);
        console.log('判断是否可以请假休假借调',resResult)
        if(!resResult){
          this.$toast(`您不能${item.name}!`);
          return false;
        }
        this.tipsFlag = true;
      }else{
        // 打卡
        this.tipsFlag = true;
      }
    },
    // 打卡
    openPunchConfirm(params){
      attendance_attendanceRecords(params).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              this.tipsFlag = false;
              this.$toast.success('今日打卡成功！');
              this.getQueryOnClock();
            }else{
              this.$toast(res.data.msg);
              return false;
            }
          }
        }
      });
    },
    // 请假、调休、借调
    getPunchOther(params){
      attendance_attendanceLeaveApplications(params).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200) {
              this.tipsFlag = false;
              this.$toast.success(res.data.msg);
              this.getQueryOnClock();
            }else{
              this.$toast.fail(res.data.msg);
              return false;
            }
          }
        }
      });
    },
    getQueryOnClock(){
      let params = {};
      if(this.userId){
        params.userId = this.userId;
      }
      if(!params.userId){
        this.$toast('无法获取userId！');
        return false;
      }
      attendance_attendanceRecords_attendanceTime(params).then((res)=>{
        if(res){
          if(res.data){
            if(res.data.code===200){
              this.stateName = res.data.data;//'休假';//'2025-10-10 12:12:12';//
              if(this.stateName!==''){
                const matchedItem = this.listType.find(item => item.name === this.stateName);
                this.listType.map((v,k)=>{
                  // 非打卡时回显
                  if(v.name === this.stateName){
                    v.checked = true;
                    v.disable = false;
                    this.current = k;
                  }else{
                    v.disable = true;
                  }
                  // 打卡时回显
                  if(!matchedItem){
                    if(v.name==='打卡'){
                      v.checked = true;
                      v.disable = false;
                    }else{
                      v.disable = true;
                    }
                  }
                });
              }
            }else{
              this.$toast(res.data.msg);
              return false;
            }
          }
        }
      });
    },
    getIsFlag(data){
      return new Promise(resolve => {
        // 后端接口返回
        attendance_attendanceLeaveApplications_judgeLeave(data).then((resData) => {
          let res = resData.data;
          if (res) {
            if (res.code && res.code === 200) {
              resolve(res.data);
            } else {
              if (res.msg) {
                this.$toast(res.msg);
              }
            }
          }
        });
      });
    },
    async initUrl() {
      try {
        // 自动登录
        await this.login1();
      } catch (err) {
        // console.log(err);
      }
    },
    async login1(){
      console.log('url_openid',this.url_openid)
      let openId = this.url_openid;//getLocalItem('open_id');
      console.log('open_id',getLocalItem('open_id'))
      if (openId === 'undefined' || openId === undefined || openId === null || openId === '') {
        this.$toast("请从微信公众号，重新登录！");
        return false;
      }else{
        if(openId.length!==28){
          this.$toast("请从微信公众号，重新登录！");
          return false;
        }
        const data = {
          tenantId: "000000",
          username: "automate",
          password: "automate",
          rememberMe: '',
          phonenumber: "12345678",
          smsCode: "1234",
          socialCode: '',
          socialState: '',
          source: '',
          code: '',
          uuid: '',
          openid: openId,
          clientId: ClientId,
          grantType: 'wxhtml',
        }
        await loginRequest(data).then((res) => {
          if(!res){
            this.$Toast('无返回数据res');
            return false;
          }
          if(!res.data){
            this.$Toast('无返回数据res.data');
            return false;
          }
          if(!res.data.data){
            this.$Toast('无返回数据res.data.data');
            return false;
          }
          if (res.data.code === 200) {
            setLocalItem('user_id', res.data.data.user_id);
            setLocalItem('roles', res.data.data.roles);
            setLocalItem('deptName', res.data.data.deptName);
            setLocalItem('phone', '');
            let nickName = res.data.data.nickName;
            if (nickName === 'undefined' || nickName === undefined || nickName === null || nickName === '') {
              nickName = "-"
            }
            setLocalItem('nickName', nickName);
            if(res.data.data.access_token){
              setLocalItem('access_token', res.data.data.access_token);
            }
            // 获得藏历数据
            this.getCalendarXZ(res.data.data.deptName);
            // 获取考勤状态
            this.getQueryOnClock();
          } else {
            this.$toast.fail(res.data.msg)
          }
        })
      }
    },
  },
  beforeDestroy() {
    if (this.removeListener) {
      this.removeListener = null;
    }
    
  },
  created() {
    this.routerType = this.$route.query.type;
    //userId
    console.log('query-userId',this.$route.query.userId)
    if(this.$route.query.userId){
      this.userId = this.$route.query.userId;
    }else if(getLocalItem('user_id')){
      this.userId = getLocalItem('user_id');
    }else{
      this.$toast('没有userId');
    }
    console.log('userId',this.userId)
    // this.url_openid = this.$route.query.openId;
    if (this.$route.query.openId) {
      this.url_openid = this.$route.query.openId;
    } else {
      this.url_openid = getLocalItem('open_id');
    }
    if(!this.routerType){
      // 从通知链接进入没有返回按钮
      //先经过自动登录接口，再进行打卡考勤接口
      this.initUrl();
    }else{
      // 专管员从首页进入
      // 获得藏历数据
      this.getCalendarXZ();
      // 获取考勤状态
      this.getQueryOnClock();
    }
    this.updateTime();
    this.removeListener = setInterval(this.updateTime, 1000);
  }
}
</script>

<template>
  <div class="home">
    <div class="head-nav">
      <van-icon v-if="routerType==='go_back'" @click="getBack" name="arrow-left" class="font" />
    </div>
    <!-- 动态日期时间显示 -->
    <div class="datetime-section">
      <div class="current-time">{{ clockTime }}</div>
      <div class="current-date">{{currentTime}}</div>
    </div>
    <!-- 主功能区域 -->
    <div class="main-section">
      <div class="card">
        <div class="punch-status">
          <div class="status-label">今日状态</div>
          <div class="status-text punched" v-if="listType[0].name==='打卡'&&listType[0].checked">已打卡</div>
          <div class="status-text" v-else-if="stateName===''">未打卡</div>
          <div class="status-text" :class="listType[current].css" v-else>{{stateName}}</div>
        </div>
        <!-- 功能按钮 -->
        <div class="actions-section">
          <div class="action-buttons">
            <div class="action-btn" :class="[!disableCheck?(item.checked?listType[current].css:''):'interrupt',item.disable?'interrupt':'']"  v-for="(item,index) in listType" :key="index"  @click="openModal(item)">
              <div class="action-icon" :class="item.css"><van-icon :name="item.icon" /></div>
              <div class="action-label" :class="item.checked?listType[current].css:''">{{item.name}}</div>
            </div>
          </div>
        </div>
        <!--显示打卡时间-->
        <div class="punch-time-display" v-if="listType[0].state===0&&listType[0].checked">
          <div class="punch-time-label">打卡时间</div>
          <div class="punch-time-value">{{ stateName }}</div>
        </div>
      </div>
    </div>
    <!--  模态弹窗-->
    <van-popup v-model="tipsFlag" round position="center" :close-on-click-overlay="false" :style="{width:'90%' }">
      <div class="inner-diag">
        <div class="title-had">
          <div class="fixed-close" @click="tipsFlag=false">&times;</div>
          <div class="section-title">
            确认{{ tipsObj.name }}
          </div>
        </div>
        <div class="tabs-group">
          <span class="pub">{{tipsObj.name}}日期：{{currentTime}}</span>
          <span class="con-app" v-if="tipsObj.name==='打卡'">我们将把打卡记录作为绩效的依据，请确认。</span>
          <span v-else>确认要申请{{tipsObj.name}}吗？</span>
        </div>
        <div class="form-buttons">
          <span class="erase" @click="tipsFlag=false">取消</span>
          <span class="leg" @click="getSubmit(tipsObj)">确认{{ tipsObj.name }}</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style scoped lang="scss">
.home{
  height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  .head-nav{
    height: 90px;
    .font{
      color: #fff;
      font-size: 40px;
      margin: 20px;
    }
  }
}
/* 日期和时间显示 */
.datetime-section {
  text-align: center;
  color: white;
  padding-top: 20px;
  padding-bottom: 30px;
}
.current-time {
  font-size: 66px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-bottom: 5px;
  text-shadow: 0 2px 10px rgba(0,0,0,0.2);
}
.current-date {
  font-size: 30px;
  opacity: 0.9;
}
.punched{
  color:#10b981;
}

/* 主功能区域 */
.main-section {
  padding: 0 20px 30px;
}

.card {
  background: white;
  border-radius: 30px;
  padding: 30px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  position: relative;
  overflow: hidden;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2);
}

/* 打卡状态 */
.punch-status {
  text-align: center;
  margin-bottom: 25px;
  padding: 25px;
  background-color: #f9fafb;
  border-radius: 15px;
}
.status-label {
  font-size: 26px;
  color: #999;
  margin-bottom: 5px;
}
.status-text {
  font-size: 30px;
  font-weight: bold;
  color: #333;
}
.status-text.punched {
  color: #10b981;
}

/* 功能按钮区 */
.actions-section {
  padding: 10px 0 20px;
}

.action-buttons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.action-btn {
  background: white;
  border: 4px solid #f3f4f6;
  border-radius: 20px;
  padding: 45px 15px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  transition: all 0.3s;
  text-decoration: none;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.interrupt{
  opacity: 0.5;
  background: #ddd;
  .action-icon{
    background: #ddd !important;
  }
}
.action-btn:active {
  transform: translateY(2px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.action-btn.punch {
  border-color: #e62d2d;
}
.action-btn.leave {
  border-color: #f59e0b;
}
.action-btn.vacation {
  border-color: #3b82f6;
}
.action-btn.transfer {
  border-color: #8b5cf6;
}
.action-icon {
  font-size: 82px;
  margin-bottom: 12px;
  background: #fff;
}

.action-icon.punch { color: #e62d2d; }
.action-icon.leave { color: #f59e0b; }
.action-icon.vacation { color: #3b82f6; }
.action-icon.transfer { color: #8b5cf6; }

.punch { color: #e62d2d; }
.leave { color: #f59e0b; }
.vacation { color: #3b82f6; }
.transfer { color: #8b5cf6; }
.action-label {
  font-size: 26px;
  font-weight: 500;
}

/* 打卡时间显示 */
.punch-time-display {
  text-align: center;
  margin-top: 35px;
  padding-top: 35px;
  border-top: 2px solid #e5e7eb;
}
.punch-time-label {
  font-size: 26px;
  color: #999;
  margin-bottom: 5px;
}
.punch-time-value {
  font-size: 28px;
  font-weight: bold;
  color: #10b981;
}

.inner-diag {
  //display: flex;
  //flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border-radius: 30px;
  .title-had{
    //position: fixed;
    //left: 0;
    //top: 0;
    //z-index: 19;
    //height: 100px;
    //width: 100%;
    padding: 40px 50px 10px;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;
    .fixed-close {
      position: absolute;
      right: 50px;
      top: 19px;
      font-size: 50px;
      color: #999;
    }
    .section-title{
      font-size: 32px;
      background: #fff;
    }
  }
  .form-buttons{
    width: 100%;
    display: inline-block;
    border-top: 1px solid #e5e7eb;
    text-align: right;
    padding-top: 20px;
    span{
      display: inline-block;
      border: 1px solid #e5e7eb;;
      padding: 15px 35px;
      border-radius: 10px;
      margin-right: 20px;
    }
    .erase{
      background: #f3f4f6;
      color: #666;
    }
    .leg{
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
    }
  }
  .tabs-group{
    padding: 60px 30px 60px;
    overflow-y: auto;
    overflow-x: hidden;
    background: #fff;
    text-align: center;
    span{
      color: #333;
      display: inline-block;
    }
    .con-app{
      color: red;
    }
    .pub{
      background: #f9fafb;
      padding:30px 15px;
      border-radius: 12px;
      margin-bottom: 20px;
    }
  }
}
</style>